var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppStatusTrackerDot = function SvgAppStatusTrackerDot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "17px",
    height: "17px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -491 -92 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 499.5 92  C 504.26 92  508 95.74  508 100.5  C 508 105.26  504.26 109  499.5 109  C 494.74 109  491 105.26  491 100.5  C 491 95.74  494.74 92  499.5 92  Z ",
    fillRule: "nonzero",
    fill: "#919ecb",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 499.5 92.5  C 503.98 92.5  507.5 96.02  507.5 100.5  C 507.5 104.98  503.98 108.5  499.5 108.5  C 495.02 108.5  491.5 104.98  491.5 100.5  C 491.5 96.02  495.02 92.5  499.5 92.5  Z ",
    strokeWidth: 1,
    stroke: "#919ecb",
    fill: "none"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppStatusTrackerDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/app_status_tracker_dot.365f960943eb71826e19933df8d9f85b.svg";